module.exports = __webpack_public_path__ + "static/media/Graph.541acdd7.png";